import { createEvent, createStore } from 'effector';

/** The ⌘K command palette (docs/PLAN.md §2.5). The `?` sheet lives in the help center. */
export const paletteOpened = createEvent();
export const paletteClosed = createEvent();
export const $paletteOpen = createStore(false)
  .on(paletteOpened, () => true)
  .reset(paletteClosed);
